import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import classNames from 'classnames';
import UserAvatar from '../../userAvatar';

const useStyles = makeStyles(({ spacing }) => ({
  root: {
    width: '100%',
    marginTop: spacing(16),
  },
  label: {
    marginBottom: spacing(8),
  },
  commentsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
  comment: {
    boxSizing: 'border-box',
    borderRadius: 8,
    borderStyle: 'solid',
    borderWidth: '1px 1px 1px 20px',
    display: 'flex',
    alignItems: 'center',
    padding: spacing(2, 4, 2, 4),
    minHeight: 48,
  },
  commentsWithUser: {
    alignItems: 'flex-start',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  user: {
    marginBottom: spacing(2),
  },
  userLabel: {
    lineHeight: '18px',
    fontSize: 14,
  },
}));

const ReportComments = ({ label, comments = [] }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.label}>
        <Typography variant="h5">{label}</Typography>
      </div>
      <div className={classes.commentsWrapper}>
        {comments.toReversed().map((comment, index) => {
          return (
            <div
              key={`comment_item_${index}`}
              className={classNames(classes.comment, {
                [classes.commentsWithUser]: !!comment.user,
              })}
              style={{
                borderColor: `${comment.color}`,
              }}
            >
              {comment.user && (
                <UserAvatar
                  className={classes.user}
                  labelClass={classes.userLabel}
                  user={comment.user}
                  caption
                  small
                />
              )}
              <Typography variant="subtitle2">{comment.text}</Typography>
            </div>
          );
        })}
      </div>
    </div>
  );
};

ReportComments.propTypes = {
  label: PropTypes.string.isRequired,
  comments: PropTypes.arrayOf(PropTypes.object),
};

export default ReportComments;
